export default function InteriorDesign() {
  const interiorFeatures = [
    {
      title: 'Panoramic Windows',
      description: 'Floor-to-ceiling curved glass provides 270° views while maintaining privacy and insulation',
      image: '/images/ai-futuristic-space-capsule-interior-with-m-e46f0b.webp'
    },
    {
      title: 'Premium Bedroom',
      description: 'Queen-size bed with luxury linens, ambient lighting, and smart controls for ultimate comfort',
      image: '/images/ai-luxury-space-capsule-bedroom-with-premiu-6056ab.webp'
    },
    {
      title: 'Modern Bathroom',
      description: 'Full bathroom with rainfall shower, premium fixtures, and efficient space utilization',
      image: '/images/ai-modern-compact-bathroom-in-space-capsule-cdc670.webp'
    },
    {
      title: 'Living Space',
      description: 'Multifunctional area with seating, workspace, and entertainment system integration',
      image: '/images/ai-futuristic-space-capsule-living-area-wit-a9f8ff.webp'
    }
  ];

  return (
    <section className="relative py-24 lg:py-32 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6">
            Interior <span className="text-cyan-400">Design</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Thoughtfully designed spaces that blend luxury, functionality, and futuristic aesthetics
          </p>
        </div>

        {/* Interior Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {interiorFeatures.map((feature, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-cyan-500/20 rounded-3xl overflow-hidden hover:border-cyan-500/50 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative w-full h-80 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-medium mb-3 text-white">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Design Philosophy */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-cyan-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-palette-line text-3xl text-cyan-400"></i>
            </div>
            <h4 className="text-lg font-medium mb-2">Minimalist Aesthetic</h4>
            <p className="text-sm text-gray-400">Clean lines and uncluttered spaces create a serene environment</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-cyan-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-layout-line text-3xl text-cyan-400"></i>
            </div>
            <h4 className="text-lg font-medium mb-2">Space Optimisation</h4>
            <p className="text-sm text-gray-400">Every inch designed for maximum functionality and comfort</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-cyan-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-line text-3xl text-cyan-400"></i>
            </div>
            <h4 className="text-lg font-medium mb-2">Premium Materials</h4>
            <p className="text-sm text-gray-400">High-quality finishes and sustainable materials throughout</p>
          </div>
        </div>
      </div>
    </section>
  );
}